module.exports = __webpack_public_path__ + "e999a34a60735dec84ac41c643ba9d6b.ico";